<script setup>

</script>

<template>
	<div class="c-skeleton" data-testid="skeleton">
		<slot></slot>
	</div>
</template>

<style lang="scss">
@import "shared/styles/settings/settings";
@import "shared/styles/tools/tools";

.c-skeleton {
	.c-skeleton__element {
		animation: skeleton-loading 2s linear infinite;
		background: linear-gradient(90deg, ds-color("bg", "status-neutral") 0%, ds-color("bg", "decorative-1-subtle") 40%, ds-color("bg", "status-neutral") 80%);
		background-attachment: fixed;
		background-size: 300%;
	}
}

@keyframes skeleton-loading {
	0% {
		background-position: -100%;
	}

	100% {
		background-position: 200%;
	}
}
</style>
